import styled from 'styled-components/macro';

export const Page = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`;

export const ButtonContainer = styled.div`
  pointer-events: none;
  position: fixed;
  bottom: 10px;
  z-index: 100;
  display: flex;
  left: 0;
  right: 0;
  transition: all 0.25s ease-in-out;

  ${({ scrollSpace }) => scrollSpace && `right: 10px;`}
`;
